export const USER_PERMISSIONS = {
  STAFF: "STAFF",
};
